import React from 'react'
import { NavLink, Outlet, useLocation } from 'react-router'
import { usePageTitle } from '../../hooks/usePageTitle'

const NOTIFICATION_TABS = [
  { to: '/account/notifikationer/indbakke', label: 'Indbakke' },
  { to: '/account/notifikationer/indstillinger', label: 'Indstillinger' },
] as const

const tabClass = ({ isActive }: { isActive: boolean }) =>
  `relative px-3 py-2 text-sm tracking-wide transition-colors focus:outline-none focus-visible:ring-1 focus-visible:ring-ink-400 ${
    isActive ? 'text-ink' : 'text-ink-500 hover:text-ink'
  }`

/**
 * Notifications section under /account — inbox + preference tabs.
 */
const AccountNotificationsPage: React.FC = () => {
  usePageTitle('Notifikationer')
  const location = useLocation()

  return (
    <div>
      <h1 className="font-serif text-2xl text-ink mb-1">Notifikationer</h1>
      <p className="text-sm text-ink-500 mb-4">
        Din indbakke og globale notifikationsindstillinger.
      </p>

      <div
        role="tablist"
        aria-label="Notifikationssektioner"
        className="border-b border-rule -mx-1 flex flex-wrap"
      >
        {NOTIFICATION_TABS.map((tab) => {
          const isActive = location.pathname === tab.to
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              role="tab"
              aria-selected={isActive}
              className={tabClass}
            >
              <span className="font-serif text-base">{tab.label}</span>
              {isActive && (
                <span
                  aria-hidden
                  className="absolute left-0 right-0 -bottom-px h-0.5 bg-signal"
                />
              )}
            </NavLink>
          )
        })}
      </div>

      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  )
}

export default AccountNotificationsPage
